import { api } from '@/redux/api/api';
import { selectGroupsById } from '@/redux/api/seletors/select-groups-by-id copy';
import { selectOrganisationById } from '@/redux/api/seletors/select-organisation-by-id';
import { selectRoleById } from '@/redux/api/seletors/select-role-by-id';
import { DispatchOptimisticPatchHandler } from '@/redux/types/dispatch-optimistic-patch-handler';
import { updateItemRecipe } from '@/redux/utils/update-item-recipe';
import { ApplicationUser } from '@/types/application-user';
import { UpdateUserQueryArg } from '../types/query-arg';

export const dispatchOptimisticPatchUpdateUser: DispatchOptimisticPatchHandler<
  UpdateUserQueryArg
> = (queryArg, { dispatch, getState }) => {
  const role = selectRoleById(queryArg.roleId)(getState());
  const organisation = queryArg.organisationId
    ? selectOrganisationById(queryArg.organisationId)(getState())
    : undefined;
  const permittedGroups = selectGroupsById(
    queryArg.permittedGroups.map((group) => {
      switch (typeof group) {
        case 'number':
          return group;
        case 'object':
          return group.value;
      }
    }),
    queryArg.organisationId ?? 0,
  )(getState());

  const patch = dispatch(
    api.util.updateQueryData(
      'getUsers',
      undefined,
      updateItemRecipe<ApplicationUser, 'id'>('id', queryArg.id, {
        ...queryArg,
        role,
        organisation,
        permittedGroups,
      }),
    ),
  );

  return { patch };
};
